import { render, staticRenderFns } from "./EmailConfirmation.vue?vue&type=template&id=2126443b&"
import script from "./EmailConfirmation.vue?vue&type=script&lang=js&"
export * from "./EmailConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./EmailConfirmation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports